// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1709":"2f970f69","5761":"c2324208","6142":"2f970f69","8020":"2f970f69"}[chunkId] + ".chunk.css";
};